import 'app/modules/administration/approve-management/approve-management.scss';
import React from 'react';
import { Row, Col, Button, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { translate } from 'react-jhipster';
import { Redirect } from 'react-router-dom';
import { reset, handleGetAccountInfo } from 'app/modules/administration/approve-management/approve-management.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import { STATUS_TYPES } from 'app/config/constants';

export interface IModalAccountInfoProps extends StateProps, DispatchProps {
  userType: string;
  login: string;
  showAccountInfoModal: boolean;
  handleAccountInfoClose: Function;
}

export interface IModalAccountInfoState {
  visible: boolean;
  color: string;
  message: string;
}

export class ModalAccountInfo extends React.Component<IModalAccountInfoProps, IModalAccountInfoState> {
  state: IModalAccountInfoState = {
    visible: false,
    color: 'danger',
    message: ''
  };

  componentDidMount() {
    if (this.props.login) {
      const { login } = this.props;
      this.props.handleGetAccountInfo(login);
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.login && this.props.login !== prevProps.login) {
      const { login } = this.props;
      this.props.handleGetAccountInfo(login);
    }
  }

  // componentWillUnmount() {
  //     this.props.reset();
  // }

  // handleDownloadFile = () => {
  //   const { accountData } = this.props;
  //   if (accountData && accountData.attachedFile) {
  //     const link = document.createElement('a');
  //     link.href = accountData.attachedFile.url;
  //     link.setAttribute('download', accountData.attachedFile.name);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // };
  onDismiss = () => {
    this.setState({ visible: false });
  };

  renderField = (name: string, label: string | JSX.Element, type?: string) => {
    const { accountData } = this.props;
    const convertCase = str => str.replace(/([A-Z])/g, '_$1').toLowerCase();
    let fieldValue =
      accountData && (accountData[name] || accountData[convertCase(name)]) ? accountData[name] || accountData[convertCase(name)] : '';
    if (type === 'Date' && fieldValue) {
      fieldValue = moment(fieldValue).format('DD/MM/YYYY');
    }
    if (name === 'status' && typeof fieldValue === 'string') {
      fieldValue = this.getMappedStatus(fieldValue);
    }
    return <AvField key={name} name={name} label={label} value={fieldValue} readOnly />;
  };

  getMappedStatus = (status: string) => {
    try {
      return STATUS_TYPES['ACCOUNT'][status];
    } catch (error) {
      // console.error("Lỗi khi ánh xạ trạng thái:", error);
      return status;
    }
  };

  render() {
    const { userType, accountData } = this.props;
    const sub = userType === 'IND' ? 'tài khoản CCVC' : 'tài khoản tổ chức';
    return (
      <div>
        <Modal
          id="modalUserExists"
          isOpen={this.props.showAccountInfoModal}
          backdrop="static"
          size="xl"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.props.handleAccountInfoClose}>
            <h3 className="font-weight-bold">Tra cứu</h3>
          </ModalHeader>
          <ModalBody>
            <div className="box-user-info" style={{ marginBottom: '60px' }}>
              <Row>
                <Col md="12">
                  <h2 className="font-weight-bold align-self-center" id="user-info-title">
                    {'Xem thông tin định danh ' + sub}
                  </h2>
                </Col>
              </Row>
              <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                {this.state.message}
              </Alert>
              <Row className="justify-content-center">
                <Col md="12">
                  <AvForm id="user-info" style={{ fontSize: '1rem' }}>
                    {/* Render những trường theo userType*/}
                    {userType === 'IND'
                      ? [
                          this.renderField(
                            'identity',
                            <span>
                              Số ĐDCN/CMND/CCCD <strong> *</strong>
                            </span>
                          ),
                          this.renderField(
                            'fullName',
                            <span>
                              Họ và tên <strong> *</strong>
                            </span>
                          ),
                          this.renderField(
                            'birthday',
                            <span>
                              Ngày sinh <strong> *</strong>
                            </span>,
                            'Date'
                          )
                        ]
                      : [
                          this.renderField(
                            'fullName',
                            <span>
                              Tên tổ chức <strong> *</strong>
                            </span>
                          ),
                          this.renderField(
                            'unitCode',
                            <span>
                              Mã tổ chức <strong> *</strong>
                            </span>
                          )
                        ]}
                    {this.renderField('email', translate('global.form.email.require'))}
                    {this.renderField('mobile', translate('global.form.mobile.label'))}
                    {/* Render những trường ngày theo userType */}

                    {userType === 'IND' ? (
                      this.renderField(
                        'approvalDate',
                        <span>
                          Ngày cấp tài khoản <strong> *</strong>
                        </span>,
                        'Date'
                      )
                    ) : (
                      <>
                        {this.renderField(
                          'requestDate',
                          <span>
                            Ngày đăng ký <strong> *</strong>
                          </span>,
                          'Date'
                        )}
                        {this.renderField(
                          'approvalDate',
                          <span>
                            Ngày cấp tài khoản <strong> *</strong>
                          </span>,
                          'Date'
                        )}
                      </>
                    )}

                    {this.renderField('status', <span>Trạng thái</span>)}
                  </AvForm>
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-confirm-white" onClick={this.props.handleAccountInfoClose}>
              Hủy
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  loading: storeState.approveManagement.loading,
  currentLocale: storeState.locale.currentLocale,
  config: storeState.applicationProfile.config,
  accountData: storeState.approveManagement.accountData
});
const mapDispatchToProps = {
  handleGetAccountInfo,
  reset
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAccountInfo);
